// src/components/auth/OAuthLogin/OAuthLoginButtons.tsx

import OAuthLoginButton from './OAuthLoginButton';

export default function OAuthLoginButtons() {
  return (
    <div className="flex flex-col gap-4">
      <OAuthLoginButton provider="google" />
      {/* Toekomstig uitbreidbaar */}
      {/* <OAuthLoginButton provider="github" /> */}
      {/* <OAuthLoginButton provider="facebook" /> */}
    </div>
  );
}